import React from 'react';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { Link } from 'react-router-dom';

const Sidebar = () => {
  return (
    <aside id='sidebar' className='sidebar'>
      <ul className='sidebar-nav' id='sidebar-nav'>
        <li className='nav-heading'>Firmware Categories</li>
        <li className='nav-item'>
          <Link className='nav-link' to='/cloudfree'>
            <i className='bi bi-cloud-fill'></i>
            <span>Cloudfree Applications</span>
          </Link>
        </li>
        <li className='nav-item'>
          <Link className='nav-link' to='/ias'>
            <i className='bi bi-cloud-upload-fill'></i>
            <span>Internet App Store</span>
          </Link>
        </li>
        <li className='nav-item'>
          <Link className='nav-link' to='/ha'>
            <i className='bi bi-cpu-fill'></i>
            <span>Home Assistant</span>
          </Link>
        </li>

        <li className='nav-heading'>Partner Companies</li>

        <li className='px-5'>
          <OverlayTrigger
            placement='right'
            overlay={
              <Tooltip id={`tooltip-right`}>
                All trademarks, logos and brand names are the property of their
                respective owners. All company, product and service names used
                in this website are for identification purposes only. Use of
                these names, trademarks and brands does not imply endorsement.​
              </Tooltip>
            }
          >
            <img
              src='/assets/img/Skyscraper_for_left_column_of_WebFlashing_120x720px_v2.png'
              alt=''
              className='img-fluid'
            />
            {/* <Button variant='secondary'>Tooltip on {placement}</Button> */}
          </OverlayTrigger>
        </li>
      </ul>

      {/* <img src='assets/img/banner.jpeg' alt='' className='img-fluid' /> */}
    </aside>
  );
}

export default Sidebar